import { T } from "@tolgee/react";
import { FC } from "react";
import { Button, ButtonProps } from "../ui/button";

export const CheckEmailExplainerCloseButton: FC<ButtonProps> = ({
  ...props
}) => {
  return (
    <Button color="indigo" {...props}>
      <T keyName="check-email-dialog-close-button-text" />
    </Button>
  );
};
